export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SignupView.vue?vue&type=template&id=6e39cf17&"


//////////////////
// WEBPACK FOOTER
// ./src/views/SignupView.vue?vue&type=template&id=6e39cf17&
// module id = 530
// module chunks = 4